import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ZONAS, PROP_TYPES } from '../../data/constants.js';

export default function SearchBar({ variant = 'hero', initial = {}, onSearch }) {
  const nav = useNavigate();
  const [op,   setOp]   = useState(initial.op   || 'venta');
  const [tipo, setTipo] = useState(initial.tipo  || '');
  const [zona, setZona] = useState(initial.zona  || '');
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const suggestions = ZONAS.map(z => z.name).filter(n => n.toLowerCase().includes(zona.toLowerCase()));

  useEffect(() => {
    const h = e => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const submit = () => {
    const p = new URLSearchParams();
    p.set('op', op);
    if (tipo) p.set('tipo', tipo);
    if (zona) p.set('zona', zona);
    nav('/buscar?' + p.toString());
    onSearch?.();
  };

  return (
    <div className={"searchbar sb-" + variant} role="search">
      <div className="sb-seg">
        <button className={"sb-op" + (op === 'venta' ? ' on' : '')} aria-pressed={op === 'venta'} onClick={() => setOp('venta')}>Comprar</button>
        <button className={"sb-op" + (op === 'alquiler' ? ' on' : '')} aria-pressed={op === 'alquiler'} onClick={() => setOp('alquiler')}>Alquilar</button>
      </div>
      <div className="sb-fields">
        <div className="sb-field">
          <label className="sb-lab" htmlFor="sb-tipo">Tipo</label>
          <div className="sb-selwrap">
            <select id="sb-tipo" className="sb-input" value={tipo} onChange={e => setTipo(e.target.value)}>
              <option value="">Cualquiera</option>
              {Object.entries(PROP_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
            <span className="sb-chev">▾</span>
          </div>
        </div>
        <div className="sb-field sb-field-grow" ref={wrapRef}>
          <label className="sb-lab" htmlFor="sb-zona">Zona o ubicación</label>
          <div className="sb-zonawrap">
            <span className="sb-zicon">📍</span>
            <input id="sb-zona" className="sb-input sb-zinput" value={zona} autoComplete="off"
              placeholder="Quilmes, Bernal, Don Bosco…"
              onFocus={() => setOpen(true)}
              onChange={e => { setZona(e.target.value); setOpen(true); }}
              onKeyDown={e => e.key === 'Enter' && submit()} />
            {open && suggestions.length > 0 && (
              <ul className="sb-sugg" role="listbox">
                {suggestions.map(z => (
                  <li key={z} role="option" onMouseDown={() => { setZona(z); setOpen(false); }}>📍 {z}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <button className="sb-go" onClick={submit} aria-label="Buscar propiedades">
          🔍 <span>Buscar</span>
        </button>
      </div>
      {variant === 'hero' && (
        <div className="sb-quick">
          {['A estrenar','Apto crédito','Con cochera','Con jardín','Con amenities'].map(q => (
            <button key={q} className="sb-qchip" onClick={() => nav('/buscar?op=' + op + '&q=' + encodeURIComponent(q))}>{q}</button>
          ))}
        </div>
      )}
    </div>
  );
}
